import { defineComponent as S, ref as m, computed as f, withDirectives as i, openBlock as V, createBlock as $, unref as o, withCtx as p, createElementVNode as n, normalizeClass as l, normalizeStyle as A, createTextVNode as c, toDisplayString as u, withModifiers as D, vShow as a, renderSlot as E, createVNode as k } from "vue";
import { messageBoxProps as H, messageEmits as L } from "./message-box.type.js";
import { ApOverlay as Z } from "../overlay/index.js";
import { useNamespace as O } from "../../hooks/use-namespace.js";
import { useZIndex as P } from "../../hooks/use-z-index.js";
import { useDraggable as U } from "../../hooks/use-draggable.js";
import { ApButton as B } from "../button/index.js";
import "./message-box.css";
import { addUnit as j } from "../utils/dom.js";
import "../AlertDialog/AlertDialog.js";
const q = {
  role: "dialog",
  "aria-modal": "true",
  class: "ap-overlay-message-box"
}, F = ["innerHTML"], G = {
  name: "ApMessageBox"
}, se = /* @__PURE__ */ S({
  ...G,
  props: H,
  emits: L,
  setup(h, { emit: x }) {
    const s = h, d = x, r = O("message-box"), { nextZIndex: z } = P(), g = m(), b = m(), v = f(() => s.draggable), M = f(() => s.buttonCenter);
    U(g, b, v);
    const T = m(s.zIndex ?? z()), I = (e) => d("update:visible", e), C = (e) => {
      I(!1), s.callback && s.callback(e);
    }, N = () => {
      d("confirm"), C("confirm");
    }, y = () => {
      d("close"), C("cancel");
    }, R = f(() => ({
      "--ap-messagebox-width": s.width ? j(s.width) : ""
    }));
    return (e, t) => i((V(), $(o(Z), {
      mask: !0,
      "z-index": T.value
    }, {
      default: p(() => [
        n("div", q, [
          n("div", {
            ref_key: "rootRef",
            ref: g,
            class: l([
              o(r).b(),
              e.dialogClass,
              o(r).is("draggable", v.value),
              o(r).is("btns-center", M.value)
            ]),
            style: A(R.value),
            id: "dialog"
          }, [
            i(n("div", {
              ref_key: "headerRef",
              ref: b,
              class: l(o(r).e("header"))
            }, [
              c(u(e.title) + " ", 1),
              i(n("a", {
                title: "close",
                class: "btn-close",
                onMousedown: t[0] || (t[0] = D(() => {
                }, ["stop"])),
                onClick: t[1] || (t[1] = (w) => y())
              }, "×", 544), [
                [a, e.showClose]
              ])
            ], 2), [
              [a, e.title]
            ]),
            n("div", {
              class: l(o(r).e("body"))
            }, [
              n("p", { innerHTML: e.message }, null, 8, F),
              E(e.$slots, "default")
            ], 2),
            n("div", {
              class: l(o(r).e("btns"))
            }, [
              i(k(o(B), {
                type: "primary",
                onClick: t[2] || (t[2] = (w) => N())
              }, {
                default: p(() => [
                  c(u(e.confirmButtonText), 1)
                ]),
                _: 1
              }, 512), [
                [a, e.showConfirmButton]
              ]),
              i(k(o(B), {
                type: "cancel",
                onClick: t[3] || (t[3] = (w) => y())
              }, {
                default: p(() => [
                  c(u(e.cancelButtonText), 1)
                ]),
                _: 1
              }, 512), [
                [a, e.showCancelButton]
              ])
            ], 2)
          ], 6)
        ])
      ]),
      _: 3
    }, 8, ["z-index"])), [
      [a, e.visible]
    ]);
  }
});
export {
  se as default
};
